import * as React from 'react';
import IconChevronLeft from '../icons/icon_chevron_left';
import IconChevronRight from '../icons/icon_chevron_right';
import useDirection from '../direction/use_direction';
import { jsx as ___EmotionJSX } from "@emotion/react";
var IconChevronStart = props => {
  var {
    isRTL
  } = useDirection();
  return isRTL ? ___EmotionJSX(IconChevronRight, props) : ___EmotionJSX(IconChevronLeft, props);
};
IconChevronStart.isVeneerIcon = true;
var IconChevronEnd = props => {
  var {
    isRTL
  } = useDirection();
  return isRTL ? ___EmotionJSX(IconChevronLeft, props) : ___EmotionJSX(IconChevronRight, props);
};
IconChevronEnd.isVeneerIcon = true;
export { IconChevronStart, IconChevronEnd };